import React from 'react';
import { Link } from 'react-router-dom';
import { cn } from './lib/utils';

/* Invisible full-cover link layer — port of `~co/common/superLink`.
   Arrow keys move focus between siblings sharing `data-tab-index`. */
export const SuperLink = React.memo(function SuperLink({
  className = '',
  active = false,
  tabIndex = -1,
  onMouseDown,
  onKeyDown,
  ...other
}) {
  const handleMouseDown = (e) => {
    e.currentTarget.focus();
    if (onMouseDown) onMouseDown(e);
  };

  const handleKeyDown = (e) => {
    switch (e.keyCode) {
      case 38: //top
        e.preventDefault();
        focusNav(e.currentTarget, 'prev');
        break;
      case 40: //bottom
        e.preventDefault();
        focusNav(e.currentTarget, 'next');
        break;
      default:
        if (onKeyDown) return onKeyDown(e);
        break;
    }
  };

  const Component = other.to ? Link : 'a';

  return (
    <Component
      {...other}
      tabIndex={tabIndex}
      className={cn('ui-superlink', className)}
      data-tab-index={tabIndex}
      onMouseDown={handleMouseDown}
      onKeyDown={handleKeyDown}
    />
  );
});

function focusNav(elem, dir = 'next') {
  const tabIndex = elem.getAttribute('data-tab-index');
  if (!tabIndex || tabIndex == '-1') return;

  const brothers = document.querySelectorAll(
    `[data-tab-index="${tabIndex}"]`,
  );

  for (var i = 0; i < brothers.length; i++)
    if (brothers[i] == elem) {
      if (dir == 'next' && brothers[i + 1]) {
        brothers[i + 1].focus();
        brothers[i + 1].click();
      } else if (dir == 'prev' && brothers[i - 1]) {
        brothers[i - 1].focus();
        brothers[i - 1].click();
      }

      break;
    }
}
